const VARIANT_STYLES = {
  empty: "border-dark-border text-dark-text-secondary",
  insufficient: "border-analytics-amber/30 text-analytics-amber",
  unavailable: "border-dark-border text-dark-text-secondary",
};

export const ProgressSectionState = ({
  variant = "empty",
  title,
  description,
  action = null,
  testId,
  className = "",
}) => (
  <div
    className={`border border-dashed bg-dark-background/50 p-6 text-center ${VARIANT_STYLES[variant] || VARIANT_STYLES.empty} ${className}`.trim()}
    data-testid={testId}
    data-state-variant={variant}
  >
    {title ? <p className="text-sm">{title}</p> : null}
    {description ? <p className="text-xs text-dark-text-muted mt-2">{description}</p> : null}
    {action ? <div className="mt-4">{action}</div> : null}
  </div>
);
